import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from './app/AuthProvider';
import { queryClient } from './lib/queryClient';
import { router } from './routes/router';
import { ToastProvider } from './shared/ui/ToastProvider';

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      {/* Outside the router on purpose: a toast viewport that lived in a route
          would vanish with it on a navigation or a route error. */}
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
